export const ROUTE_PATH = '/album/:id/settings';